import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

type KbdKeysInput = string | readonly string[];
type KbdSize = 'md' | 'sm';

@Component({
  selector: 'app-platform-kbd',
  template: `
    <span
      class="ct-kbd"
      [class.ct-kbd--sm]="size() === 'sm'"
      [attr.aria-label]="ariaLabel()"
    >
      @for (key of normalizedKeys(); track key + '-' + $index) {
        <kbd class="ct-kbd__key">{{ key }}</kbd>
      }
    </span>
  `,
  styleUrl: './platform-kbd.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlatformKbdComponent {
  readonly keys = input<KbdKeysInput>('Esc');
  readonly size = input<KbdSize>('md');
  readonly ariaLabelOverride = input<string | null>(null);

  readonly normalizedKeys = computed(() => {
    const keys = this.keys();
    const arr = Array.isArray(keys) ? keys : [keys];
    return arr.map((key) => `${key}`.trim()).filter(Boolean);
  });

  readonly ariaLabel = computed(() => {
    const override = this.ariaLabelOverride();
    if (override) {
      return override;
    }
    return this.normalizedKeys().join(' + ');
  });
}
